'use strict';

import appModule from '../app.module';

var TRANSLATIONS = {
  fr: {
    'nav.openBudget':               'Open Budget',
    'nav.budgetGeneral':            'Budget général',
    'nav.budgetLocal':              'Budget local',
    'nav.budgetCitoyen':            'Budget citoyen',
    'nav.budgetInvestissements':    "Budget d'investissements",
    'nav.secteurPetrolier':         'Secteur pétrolier',
    'nav.contratsPetroliers':       'Contrats pétroliers',
    'nav.autorisationsRecherche':   'Autorisations de recherche',
    'nav.autorisationsExploitation':"Autorisations d'exploitation",
    'nav.secteurMinier':            'Secteur minier',
    'nav.conventionsMinieres':      'Conventions minières',
    'nav.titresMiniers':            'Titres miniers',
    'nav.autorisationsMinieres':    'Autorisations minières',
    'nav.documents':                'Documents',
    'nav.textesOfficiels':          'Textes officiels',
    'nav.publications':             'Publications',
    'nav.videotheque':              'Vidéothèque',
    'nav.actualites':               'Actualités',
    'nav.datasets':                 'Jeux de données',
    'nav.organisations':            'Organisations',
    'nav.glossaire':                'Glossaire',
    'nav.forum':                    'Forum',
    'nav.contact':                  'Contact',
    'nav.secteurs':                 'Secteurs',
    'nav.ressources':               'Ressources',
    'nav.decouvrezApps':            'Découvrez toutes nos applications',
    'nav.connexion':                'Connexion',
    'nav.inscription':              'Inscription',
    'nav.monCompte':                'Mon compte',
    'nav.mesFavoris':               'Mes favoris',
    'nav.espaceAdmin':              "Espace d'administration",
    'nav.deconnexion':              'Déconnexion',
    'footer.question':              'Une question ? Besoin d\'aide ?',
    'footer.equipe':                'Notre équipe est disponible pour vous accompagner.',
    'footer.nousContacter':         'Nous contacter',
    'footer.droits':                'Tous droits réservés.',
    'footer.politiqueConf':         'Politique de confidentialité',
    'footer.mentionsLegales':       'Mentions légales',
    'global.menu.home':             'Accueil',

    'modal.logout.title':           'Se déconnecter ?',
    'modal.logout.body':            'Votre session sera terminée et vous serez redirigé vers la page de connexion.',
    'modal.logout.cancel':          'Annuler',
    'modal.logout.confirm':         'Déconnexion',
    'modal.session.title':          'Session bientôt expirée',
    'modal.session.expireIn':       'Votre session va expirer dans',
    'modal.session.hint':           'Cliquez sur « Rester connecté » pour prolonger votre session.',
    'modal.session.logout':         'Se déconnecter',
    'modal.session.stay':           'Rester connecté',

    'common.search':                'Rechercher',
    'common.searching':             'Recherche…',
    'common.loading':               'Chargement...',
    'common.noResults':             'Aucun résultat pour',
    'common.seeAllResults':         'Voir tous les résultats pour',
    'common.visualize':             'Visualiser',
    'common.download':              'Télécharger',
    'common.fileUnavailable':       'Fichier non disponible',
    'common.readArticle':           "Lire l'article",
    'common.required':              'Requis',
    'common.all':                   'Toutes',
    'common.filter':                'Filtrer',
    'common.resetFilters':          'Réinitialiser les filtres',
    'common.noMatchSearch':         'Aucun résultat ne correspond à votre recherche.',
    'common.showPer':               'Afficher par :',
    'common.addFavorite':           'Ajouter aux favoris',
    'common.removeFavorite':        'Retirer des favoris',
    'common.favorite':              'Favori',
    'common.allCategories':         'Toutes les catégories',
    'common.allYears':              'Toutes les années',
    'common.views':                 'vues',
    'common.watch':                 'Regarder',
    'common.reset':                 'Réinitialiser',
    'common.advancedFilters':       'Filtres avancés',
    'common.rateDoc':               'Notez le document :',
    'common.loadingPubs':           'Chargement des publications...',
    'common.loadingActus':          'Chargement des actualités...',
    'common.loadingVideos':         'Chargement des vidéos...',
    'common.loadingData':           'Chargement des données...',

    'actualites.badge':             'Actualités',
    'actualites.title':             'Actualités',
    'actualites.sub':               'Restez informé des dernières nouvelles sur les finances publiques du Tchad',
    'actualites.articles':          'articles',
    'actualites.categories':        'catégories',
    'actualites.featured':          'À la une',
    'actualites.searchPh':          'Rechercher une actualité...',
    'actualites.noResult':          'Aucune actualité ne correspond à votre recherche.',
    'actualites.allTitle':          'Toutes les actualités',

    'publications.badge':           'Publications',
    'publications.title':           'Publications',
    'publications.sub':             "Découvrez toutes les publications et documents de l'Observatoire Tchadien des Finances Publiques",
    'publications.searchPh':        'Rechercher par titre, auteur, catégorie, mots-clés...',
    'publications.noResult':        'Aucune publication ne correspond à',
    'publications.noCategory':      'Sans catégorie',

    'videotheque.badge':            'Vidéothèque',
    'videotheque.title':            'Vidéothèque',
    'videotheque.sub':              "Explorez les ressources vidéo de l'Observatoire Tchadien des Finances Publiques, incluant des données des secteurs pétrolier et minier.",
    'videotheque.searchPh':         'Rechercher une vidéo...',
    'videotheque.allDurations':     'Toutes durées',
    'videotheque.allMonths':        'Tous les mois',
    'videotheque.noResult':         'Aucune vidéo trouvée',
    'videotheque.noResultDesc':     'Aucune vidéo ne correspond à vos critères de recherche.',
    'videotheque.available':        'vidéos disponibles',
    'videotheque.short':            'Courte (< 10 min)',
    'videotheque.medium':           'Moyenne (10-30 min)',
    'videotheque.long':             'Longue (> 30 min)',

    'textes.badge':                 'Textes Officiels',
    'textes.title':                 'Textes officiels',
    'textes.sub':                   'Consultez les textes législatifs et réglementaires sur les finances publiques du Tchad',
    'textes.searchPh':              'Rechercher un texte officiel...',
    'textes.noResult':              'Aucun texte officiel ne correspond à votre recherche.',

    'forum.badge':                  'Forum',
    'forum.title':                  'Forum de discussion',
    'forum.sub':                    'Échangez avec la communauté sur les finances publiques du Tchad',
    'forum.newTopic':               'Nouveau sujet',
    'forum.searchPh':               'Rechercher un sujet...',
    'forum.noResult':               'Aucun sujet ne correspond à votre recherche.',
    'forum.loginRequired':          'Connexion requise pour poster',

    'glossaire.badge':              'Glossaire',
    'glossaire.title':              'Glossaire',
    'glossaire.sub':                'Définitions des termes liés aux finances publiques et à la transparence',
    'glossaire.searchPh':           'Rechercher un terme...',
    'glossaire.noResult':           'Aucun terme ne correspond à votre recherche.',

    'sector.oil.title':             'Secteur Pétrolier',
    'sector.oil.sub':               "Données et statistiques sur l'industrie pétrolière au Tchad",
    'sector.oil.year':              'Année',
    'sector.oil.production':        'Production',

    'contrats.badge':               'Secteur Pétrolier',
    'contrats.title':               'Contrats pétroliers',
    'contrats.sub':                 "Accords conclus entre l'État tchadien et les compagnies pétrolières pour l'exploration et l'exploitation des ressources pétrolières du pays",
    'contrats.searchPh':            'Rechercher par dénomination, NIF, référence...',
    'contrats.filters':             'Filtres de recherche',
    'contrats.denomination':        'Dénomination',
    'contrats.matiere':             'Matière contractée',
    'contrats.type':                'Type de contrat',
    'contrats.status':              'Statut',
    'contrats.noResult':            'Aucun contrat ne correspond à votre recherche.',

    'conventions.badge':            'Secteur Minier',
    'conventions.title':            'Conventions minières',
    'conventions.sub':              "Liste des conventions minières signées entre l'État tchadien et les compagnies minières pour l'exploration et l'exploitation des ressources minières du pays",
    'conventions.searchPh':         'Rechercher une convention...',
    'conventions.filters':          'Filtres de recherche',
    'conventions.keyword':          'Mot-clé',
    'conventions.region':           'Région',
    'conventions.allRegions':       'Toutes les régions',
    'conventions.substance':        'Substance',
    'conventions.allSubstances':    'Toutes les substances',
    'conventions.allStatuts':       'Tous les statuts',
    'conventions.anneeMin':         'Année min',
    'conventions.noResult':         'Aucune convention ne correspond à votre recherche.',

    'titres.badge':                 'Secteur Minier',
    'titres.title':                 'Titres miniers',
    'titres.sub':                   "Titres miniers accordés par l'État tchadien pour l'exploration et l'exploitation des ressources minières",
    'titres.searchPh':              'Rechercher un titre minier...',
    'titres.noResult':              'Aucun titre minier ne correspond à votre recherche.',

    'autorisations.badge':          'Secteur Pétrolier',
    'autorisations.searchPh':       'Rechercher une autorisation...',
    'autorisations.noResult':       'Aucune autorisation ne correspond à votre recherche.',
    'autorisations.recherche.title':'Autorisations de Recherche',
    'autorisations.recherche.sub':  "Autorisations accordées pour la recherche d'hydrocarbures au Tchad",
    'autorisations.exploitation.title': "Autorisations d'Exploitation",
    'autorisations.exploitation.sub':   "Autorisations accordées pour l'exploitation d'hydrocarbures au Tchad",
    'autorisations.minieres.badge': 'Secteur Minier',
    'autorisations.minieres.title': 'Autorisations Minières',
    'autorisations.minieres.sub':   "Autorisations accordées pour l'exploration et l'exploitation minière au Tchad",

    'apps.badge':                   'Applications mobiles',
    'apps.title':                   'Nos Applications',
    'apps.sub':                     'Accédez aux données et services financiers du Tchad directement depuis votre smartphone',
    'apps.downloadIos':             'Télécharger sur',
    'apps.downloadAndroid':         'Disponible sur',

    'legal.badge':                  'Informations légales',
    'legal.title':                  'Mentions légales',
    'legal.update':                 'Dernière mise à jour : mai 2026',

    'privacy.badge':                'Données personnelles',
    'privacy.title':                'Politique de confidentialité',
    'privacy.update':               'Dernière mise à jour : mai 2026',

    'footer.community':             'Rejoignez-nous',
    'footer.brandDesc':             "Plateforme nationale de transparence des finances publiques, favorisant l'accès aux données budgétaires et financières du Tchad.",
    'footer.followUs':              'Suivez-nous',
    'footer.mobileApps':            'Applications mobiles',
    'footer.applications':          'Applications',

    'footer.stat.datasets':         'Jeux de données',
    'footer.stat.publications':     'Publications',
    'footer.stat.textes':           'Textes officiels',
    'footer.stat.users':            'Utilisateurs',

    'newsletter.title':             "Lettre d'information",
    'newsletter.desc':              "Inscrivez-vous pour recevoir chaque mois la lettre d'information et être tenu informé des dernières actualités de l'Observatoire.",
    'newsletter.placeholder':       'Votre adresse email',
    'newsletter.btn':               "S'abonner",
    'newsletter.success':           'Merci pour votre inscription !',

    'home.heroTag':                 'Transparence & Finances Publiques',
    'home.heroSubtitle':            'Accédez aux données financières, minières et pétrolières du Tchad',
    'home.searchPlaceholder':       'Rechercher dans tout l\'Observatoire…',
    'home.budgetTitle':             'Budget ouvert — Jeux de données',
    'home.budgetDesc':              'Informations prévues dans les lois de finances annuelles, évaluation de la performance budgétaire et répartition des recettes et dépenses.',
    'home.videosTitle':             'Vidéos récentes',
    'home.videosDesc':              'Notes du secteur extractif, vidéos explicatives sur les lois de finances annuelles et actualités des finances publiques du Tchad.',
    'home.videosBtn':               'Consulter toutes les vidéos',
    'home.appPretitle':             'Application mobile',
    'home.appTitle':                'L\'Observatoire Tchadien des Finances Publiques',
    'home.appDesc':                 'Votre nouvel allié pour tout savoir sur les finances publiques du Tchad',
    'home.pubBadge':                'Publications',
    'home.pubSectionTitle':         'Ressources documentaires',
    'home.pubSectionDesc':          'Rapports, études et documents officiels sur les finances publiques du Tchad',
    'home.pubAllLink':              'Toutes les publications',
    'home.pubRecent':               'Dernières publications',
    'home.pubFeatured':             'Publications en vedette',
    'home.pubNoRecent':             'Aucune publication récente',
    'home.pubNoFeatured':           'Aucune publication en vedette',
    'home.actuBadge':               'Actualités',
    'home.actuTitle':               'Dernières actualités',
    'home.actuDesc':                'Suivez les dernières nouvelles sur les finances publiques du Tchad',
    'home.actuAllLink':             'Voir toutes les actualités',
    'home.actuEmpty':               'Aucune actualité disponible pour le moment.',
    'home.actuAllBtn':              'Toutes les actualités',
    'home.views':                   'vues',

    'login.welcome':                'Bon retour !',
    'login.subtitle':               'Connectez-vous à votre espace personnel',
    'login.successMsg':             'Compte créé avec succès. Vous pouvez vous connecter.',
    'login.username':               "Nom d'utilisateur",
    'login.usernamePlaceholder':    'Votre identifiant',
    'login.usernameRequired':       "Le nom d'utilisateur est requis",
    'login.password':               'Mot de passe',
    'login.passwordPlaceholder':    'Votre mot de passe',
    'login.passwordRequired':       'Le mot de passe est requis',
    'login.rememberMe':             'Se souvenir de moi',
    'login.forgotPassword':         'Mot de passe oublié ?',
    'login.submit':                 'Se connecter',
    'login.submitting':             'Connexion...',
    'login.noAccount':              'Pas encore de compte ?',
    'login.createAccount':          'Créer un compte',
    'login.feature1':               'Accès aux données budgétaires',
    'login.feature2':               'Suivi des ressources pétrolières et minières',
    'login.feature3':               'Textes officiels et publications',

    'register.title':               'Créer un compte',
    'register.subtitle':            'Remplissez le formulaire pour vous inscrire',
    'register.step1':               'Créez votre compte gratuitement',
    'register.step2':               'Accédez aux données et publications',
    'register.step3':               'Participez aux discussions du forum',
    'register.firstName':           'Prénom',
    'register.firstNamePh':         'Votre prénom',
    'register.lastName':            'Nom',
    'register.lastNamePh':          'Votre nom',
    'register.username':            "Nom d'utilisateur",
    'register.usernamePh':          'Choisissez un identifiant (3–20 caractères)',
    'register.usernameRequired':    "Le nom d'utilisateur est requis",
    'register.usernameMin':         'Minimum 3 caractères',
    'register.usernameMax':         'Maximum 20 caractères',
    'register.email':               'Adresse e-mail',
    'register.emailRequired':       "L'email est requis",
    'register.emailInvalid':        'Email invalide',
    'register.password':            'Mot de passe',
    'register.passwordPh':          'Min. 6 caractères',
    'register.passwordMin':         'Min. 6 caractères',
    'register.confirm':             'Confirmation',
    'register.confirmPh':           'Répétez le mot de passe',
    'register.confirmMismatch':     'Ne correspondent pas',
    'register.terms':               "J'accepte les",
    'register.termsLink':           "conditions d'utilisation",
    'register.and':                 'et la',
    'register.privacyLink':         'politique de confidentialité',
    'register.termsRequired':       "Vous devez accepter les conditions d'utilisation",
    'register.captcha':             'Verification anti-robot',
    'register.captchaRequired':     'Veuillez compléter la vérification anti-robot',
    'register.submit':              'Créer mon compte',
    'register.submitting':          'Inscription en cours...',
    'register.alreadyMember':       'Déjà inscrit ?',
    'register.login':               'Se connecter',

    'account.title':                'Mon Compte',
    'account.subtitle':             'Gérez vos informations personnelles et paramètres de sécurité',
    'account.tabProfile':           'Profil',
    'account.tabSecurity':          'Sécurité',
    'account.personalInfo':         'Informations personnelles',
    'account.loginInfo':            'Informations de connexion',
    'account.firstName':            'Prénom',
    'account.lastName':             'Nom',
    'account.username':             "Nom d'utilisateur",
    'account.usernameReadonly':     'Non modifiable',
    'account.email':                'Adresse email',
    'account.emailInvalid':         "Format d'email invalide",
    'account.phone':                'Téléphone',
    'account.preferredLang':        'Langue préférée',
    'account.langFr':               'Français',
    'account.langEn':               'Anglais',
    'account.langAr':               'Arabe',
    'account.saving':               'Enregistrement...',
    'account.save':                 'Enregistrer les modifications',
    'account.role':                 'Utilisateur',
    'account.changePassword':       'Changer le mot de passe',
    'account.currentPassword':      'Mot de passe actuel',
    'account.newPassword':          'Nouveau mot de passe',
    'account.passwordMin':          'Minimum 6 caractères',
    'account.confirmPassword':      'Confirmer le mot de passe',
    'account.passwordMismatch':     'Les mots de passe ne correspondent pas',
    'account.changing':             'Modification...',
    'account.changeBtn':            'Changer le mot de passe',

    'contact.badge':                'Contact',
    'contact.title':                'Contactez-nous',
    'contact.sub':                  'Notre équipe est disponible pour répondre à toutes vos questions sur la transparence des finances publiques du Tchad.',
    'contact.hours':                'Lun – Ven : 7h30 – 15h30',
    'contact.ourCoords':            'Nos coordonnées',
    'contact.coordsDesc':           'N\'hésitez pas à nous joindre par l\'un des canaux ci-dessous.',
    'contact.address':              'Adresse',
    'contact.phone':                'Téléphone',
    'contact.openHours':            'Heures d\'ouverture',
    'contact.openHoursVal':         'Lundi – Vendredi : 7h30 – 15h30',
    'contact.followUs':             'Suivez-nous sur les réseaux',
    'contact.formTitle':            'Envoyez-nous un message',
    'contact.formDesc':             'Complétez le formulaire ci-dessous et nous vous répondrons dans les meilleurs délais.',
    'contact.fullName':             'Nom complet',
    'contact.fullNamePh':           'Votre nom complet',
    'contact.nameRequired':         'Le nom est requis.',
    'contact.emailInvalid':         'Email invalide.',
    'contact.subject':              'Sujet',
    'contact.subjectPh':            'Objet de votre message',
    'contact.message':              'Message',
    'contact.messagePh':            'Décrivez votre demande...',
    'contact.send':                 'Envoyer le message',
    'contact.sending':              'Envoi en cours...',
    'contact.successTitle':         'Message envoyé !',
    'contact.successDesc':          'Nous vous répondrons dans les plus brefs délais.',
    'contact.errorTitle':           'Erreur d\'envoi',
    'contact.errorDesc':            'Une erreur s\'est produite. Veuillez réessayer ou nous contacter par email.',
    'contact.findUs':               'Nous trouver',

    'notfound.title':               'Page introuvable',
    'notfound.desc':                'La page que vous cherchez n\'existe pas ou a été déplacée.',
    'notfound.hint':                'Vérifiez l\'URL ou utilisez les liens ci-dessous pour naviguer.',
    'notfound.backHome':            'Retour à l\'accueil',
    'notfound.usefulLinks':         'Pages utiles',

    'favorites.title':              'Mes Favoris',
    'favorites.sub':                'Retrouvez ici tous vos jeux de données, publications, textes officiels et vidéos enregistrés',
    'favorites.noFavs':             'Aucun favori enregistré',
    'favorites.searchPh':           'Rechercher dans vos favoris...',
    'favorites.loginRequired':      'Connexion requise',
    'favorites.loginDesc':          'Connectez-vous pour accéder à vos favoris personnels.',
    'favorites.login':              'Se connecter',
    'favorites.empty':              'Vous n\'avez pas encore de favoris.',
    'favorites.emptyDesc':          'Parcourez le site et cliquez sur l\'étoile pour sauvegarder des contenus.',

    'search.title':                 'Résultats de recherche',
    'search.placeholder':           'Rechercher dans tout l\'Observatoire...',
    'search.btn':                   'Rechercher',
    'search.searching':             'Recherche en cours…',
    'search.noResult':              'Aucun résultat pour',
    'search.noResultHint':          'Essayez avec d\'autres mots-clés ou parcourez les sections ci-dessous.',
    'search.results':               'résultat(s) pour'
  },
  en: {
    'nav.openBudget':               'Open Budget',
    'nav.budgetGeneral':            'General Budget',
    'nav.budgetLocal':              'Local Budget',
    'nav.budgetCitoyen':            'Citizen Budget',
    'nav.budgetInvestissements':    'Investment Budget',
    'nav.secteurPetrolier':         'Oil Sector',
    'nav.contratsPetroliers':       'Oil Contracts',
    'nav.autorisationsRecherche':   'Research Permits',
    'nav.autorisationsExploitation':'Exploitation Permits',
    'nav.secteurMinier':            'Mining Sector',
    'nav.conventionsMinieres':      'Mining Conventions',
    'nav.titresMiniers':            'Mining Titles',
    'nav.autorisationsMinieres':    'Mining Permits',
    'nav.documents':                'Documents',
    'nav.textesOfficiels':          'Official Texts',
    'nav.publications':             'Publications',
    'nav.videotheque':              'Video Library',
    'nav.actualites':               'News',
    'nav.datasets':                 'Datasets',
    'nav.organisations':            'Organisations',
    'nav.glossaire':                'Glossary',
    'nav.forum':                    'Forum',
    'nav.contact':                  'Contact',
    'nav.secteurs':                 'Sectors',
    'nav.ressources':               'Resources',
    'nav.decouvrezApps':            'Discover all our applications',
    'nav.connexion':                'Login',
    'nav.inscription':              'Sign Up',
    'nav.monCompte':                'My Account',
    'nav.mesFavoris':               'My Favorites',
    'nav.espaceAdmin':              'Admin Area',
    'nav.deconnexion':              'Logout',
    'footer.question':              'A question? Need help?',
    'footer.equipe':                'Our team is available to assist you.',
    'footer.nousContacter':         'Contact us',
    'footer.droits':                'All rights reserved.',
    'footer.politiqueConf':         'Privacy Policy',
    'footer.mentionsLegales':       'Legal Notice',
    'global.menu.home':             'Home',

    'modal.logout.title':           'Log out?',
    'modal.logout.body':            'Your session will end and you will be redirected to the login page.',
    'modal.logout.cancel':          'Cancel',
    'modal.logout.confirm':         'Log out',
    'modal.session.title':          'Session expiring soon',
    'modal.session.expireIn':       'Your session expires in',
    'modal.session.hint':           'Click "Stay connected" to extend your session.',
    'modal.session.logout':         'Log out',
    'modal.session.stay':           'Stay connected',

    'common.search':                'Search',
    'common.searching':             'Searching…',
    'common.loading':               'Loading...',
    'common.noResults':             'No results for',
    'common.seeAllResults':         'See all results for',
    'common.visualize':             'View',
    'common.download':              'Download',
    'common.fileUnavailable':       'File unavailable',
    'common.readArticle':           'Read article',
    'common.required':              'Required',
    'common.all':                   'All',
    'common.filter':                'Filter',
    'common.resetFilters':          'Reset filters',
    'common.noMatchSearch':         'No results match your search.',
    'common.showPer':               'Show per:',
    'common.addFavorite':           'Add to favorites',
    'common.removeFavorite':        'Remove from favorites',
    'common.favorite':              'Favorite',
    'common.allCategories':         'All categories',
    'common.allYears':              'All years',
    'common.views':                 'views',
    'common.watch':                 'Watch',
    'common.reset':                 'Reset',
    'common.advancedFilters':       'Advanced filters',
    'common.rateDoc':               'Rate this document:',
    'common.loadingPubs':           'Loading publications...',
    'common.loadingActus':          'Loading news...',
    'common.loadingVideos':         'Loading videos...',
    'common.loadingData':           'Loading data...',

    'actualites.badge':             'News',
    'actualites.title':             'News',
    'actualites.sub':               'Stay informed about the latest news on public finance in Chad',
    'actualites.articles':          'articles',
    'actualites.categories':        'categories',
    'actualites.featured':          'Featured',
    'actualites.searchPh':          'Search for news...',
    'actualites.noResult':          'No news matches your search.',
    'actualites.allTitle':          'All news',

    'publications.badge':           'Publications',
    'publications.title':           'Publications',
    'publications.sub':             'Discover all publications and documents from the Chadian Public Finance Observatory',
    'publications.searchPh':        'Search by title, author, category, keywords...',
    'publications.noResult':        'No publication matches',
    'publications.noCategory':      'Uncategorized',

    'videotheque.badge':            'Video Library',
    'videotheque.title':            'Video Library',
    'videotheque.sub':              'Explore video resources from the Chadian Public Finance Observatory, including extractive sector and financial transparency data.',
    'videotheque.searchPh':         'Search for a video...',
    'videotheque.allDurations':     'All durations',
    'videotheque.allMonths':        'All months',
    'videotheque.noResult':         'No videos found',
    'videotheque.noResultDesc':     'No video matches your search criteria.',
    'videotheque.available':        'videos available',
    'videotheque.short':            'Short (< 10 min)',
    'videotheque.medium':           'Medium (10-30 min)',
    'videotheque.long':             'Long (> 30 min)',

    'textes.badge':                 'Official Texts',
    'textes.title':                 'Official texts',
    'textes.sub':                   'Consult legislative and regulatory texts on public finance in Chad',
    'textes.searchPh':              'Search for an official text...',
    'textes.noResult':              'No official text matches your search.',

    'forum.badge':                  'Forum',
    'forum.title':                  'Discussion forum',
    'forum.sub':                    'Exchange with the community about public finance in Chad',
    'forum.newTopic':               'New topic',
    'forum.searchPh':               'Search for a topic...',
    'forum.noResult':               'No topic matches your search.',
    'forum.loginRequired':          'Login required to post',

    'glossaire.badge':              'Glossary',
    'glossaire.title':              'Glossary',
    'glossaire.sub':                'Definitions of terms related to public finance and transparency',
    'glossaire.searchPh':           'Search for a term...',
    'glossaire.noResult':           'No term matches your search.',

    'sector.oil.title':             'Oil Sector',
    'sector.oil.sub':               'Data and statistics on the oil industry in Chad',
    'sector.oil.year':              'Year',
    'sector.oil.production':        'Production',

    'contrats.badge':               'Oil Sector',
    'contrats.title':               'Oil contracts',
    'contrats.sub':                 'Agreements concluded between the Chadian State and oil companies for the exploration and exploitation of oil resources',
    'contrats.searchPh':            'Search by name, TIN, reference...',
    'contrats.filters':             'Search filters',
    'contrats.denomination':        'Denomination',
    'contrats.matiere':             'Contracted subject',
    'contrats.type':                'Contract type',
    'contrats.status':              'Status',
    'contrats.noResult':            'No contract matches your search.',

    'conventions.badge':            'Mining Sector',
    'conventions.title':            'Mining conventions',
    'conventions.sub':              'List of mining conventions signed between the Chadian State and mining companies for the exploration and exploitation of mineral resources',
    'conventions.searchPh':         'Search for a convention...',
    'conventions.filters':          'Search filters',
    'conventions.keyword':          'Keyword',
    'conventions.region':           'Region',
    'conventions.allRegions':       'All regions',
    'conventions.substance':        'Substance',
    'conventions.allSubstances':    'All substances',
    'conventions.allStatuts':       'All statuses',
    'conventions.anneeMin':         'Min year',
    'conventions.noResult':         'No convention matches your search.',

    'titres.badge':                 'Mining Sector',
    'titres.title':                 'Mining titles',
    'titres.sub':                   'Mining titles granted by the Chadian State for the exploration and exploitation of mineral resources',
    'titres.searchPh':              'Search for a mining title...',
    'titres.noResult':              'No mining title matches your search.',

    'autorisations.badge':          'Oil Sector',
    'autorisations.searchPh':       'Search for a permit...',
    'autorisations.noResult':       'No permit matches your search.',
    'autorisations.recherche.title':'Research Permits',
    'autorisations.recherche.sub':  'Permits granted for hydrocarbon exploration in Chad',
    'autorisations.exploitation.title': 'Exploitation Permits',
    'autorisations.exploitation.sub':   'Permits granted for hydrocarbon exploitation in Chad',
    'autorisations.minieres.badge': 'Mining Sector',
    'autorisations.minieres.title': 'Mining Permits',
    'autorisations.minieres.sub':   'Permits granted for mining exploration and exploitation in Chad',

    'apps.badge':                   'Mobile Applications',
    'apps.title':                   'Our Applications',
    'apps.sub':                     'Access Chad\'s financial data and services directly from your smartphone',
    'apps.downloadIos':             'Download on the',
    'apps.downloadAndroid':         'Get it on',

    'footer.community':             'Join us',
    'footer.brandDesc':             'National platform for public finance transparency, promoting access to budget and financial data of Chad.',
    'footer.followUs':              'Follow us',
    'footer.mobileApps':            'Mobile applications',
    'footer.applications':          'Applications',

    'footer.stat.datasets':         'Datasets',
    'footer.stat.publications':     'Publications',
    'footer.stat.textes':           'Official texts',
    'footer.stat.users':            'Users',

    'newsletter.title':             'Newsletter',
    'newsletter.desc':              'Subscribe to receive the monthly newsletter and stay informed about the latest news from the Observatory.',
    'newsletter.placeholder':       'Your email address',
    'newsletter.btn':               'Subscribe',
    'newsletter.success':           'Thank you for subscribing!',

    'legal.badge':                  'Legal Information',
    'legal.title':                  'Legal Notice',
    'legal.update':                 'Last updated: May 2026',

    'privacy.badge':                'Personal Data',
    'privacy.title':                'Privacy Policy',
    'privacy.update':               'Last updated: May 2026',

    'home.heroTag':                 'Transparency & Public Finance',
    'home.heroSubtitle':            'Access financial, mining and oil data of Chad',
    'home.searchPlaceholder':       'Search the entire Observatory…',
    'home.budgetTitle':             'Open Budget — Datasets',
    'home.budgetDesc':              'Information provided in annual finance laws, budget performance assessment and breakdown of revenues and expenditures.',
    'home.videosTitle':             'Recent Videos',
    'home.videosDesc':              'Extractive sector notes, explanatory videos on annual finance laws and public finance news from Chad.',
    'home.videosBtn':               'Browse all videos',
    'home.appPretitle':             'Mobile Application',
    'home.appTitle':                'The Chadian Public Finance Observatory',
    'home.appDesc':                 'Your new ally for everything about public finance in Chad',
    'home.pubBadge':                'Publications',
    'home.pubSectionTitle':         'Documentary Resources',
    'home.pubSectionDesc':          'Reports, studies and official documents on public finance in Chad',
    'home.pubAllLink':              'All publications',
    'home.pubRecent':               'Latest publications',
    'home.pubFeatured':             'Featured publications',
    'home.pubNoRecent':             'No recent publications',
    'home.pubNoFeatured':           'No featured publications',
    'home.actuBadge':               'News',
    'home.actuTitle':               'Latest news',
    'home.actuDesc':                'Follow the latest news on public finance in Chad',
    'home.actuAllLink':             'See all news',
    'home.actuEmpty':               'No news available at the moment.',
    'home.actuAllBtn':              'All news',
    'home.views':                   'views',

    'login.welcome':                'Welcome back!',
    'login.subtitle':               'Sign in to your personal space',
    'login.successMsg':             'Account created successfully. You can now sign in.',
    'login.username':               'Username',
    'login.usernamePlaceholder':    'Your username',
    'login.usernameRequired':       'Username is required',
    'login.password':               'Password',
    'login.passwordPlaceholder':    'Your password',
    'login.passwordRequired':       'Password is required',
    'login.rememberMe':             'Remember me',
    'login.forgotPassword':         'Forgot password?',
    'login.submit':                 'Sign in',
    'login.submitting':             'Signing in...',
    'login.noAccount':              'No account yet?',
    'login.createAccount':          'Create an account',
    'login.feature1':               'Access to budget data',
    'login.feature2':               'Tracking oil and mining resources',
    'login.feature3':               'Official texts and publications',

    'register.title':               'Create an account',
    'register.subtitle':            'Fill in the form to register',
    'register.step1':               'Create your account for free',
    'register.step2':               'Access data and publications',
    'register.step3':               'Join forum discussions',
    'register.firstName':           'First name',
    'register.firstNamePh':         'Your first name',
    'register.lastName':            'Last name',
    'register.lastNamePh':          'Your last name',
    'register.username':            'Username',
    'register.usernamePh':          'Choose a username (3–20 characters)',
    'register.usernameRequired':    'Username is required',
    'register.usernameMin':         'Minimum 3 characters',
    'register.usernameMax':         'Maximum 20 characters',
    'register.email':               'Email address',
    'register.emailRequired':       'Email is required',
    'register.emailInvalid':        'Invalid email',
    'register.password':            'Password',
    'register.passwordPh':          'Min. 6 characters',
    'register.passwordMin':         'Min. 6 characters',
    'register.confirm':             'Confirm password',
    'register.confirmPh':           'Repeat your password',
    'register.confirmMismatch':     'Passwords do not match',
    'register.terms':               'I accept the',
    'register.termsLink':           'terms of use',
    'register.and':                 'and the',
    'register.privacyLink':         'privacy policy',
    'register.termsRequired':       'You must accept the terms of use',
    'register.captcha':             'Anti-bot verification',
    'register.captchaRequired':     'Please complete the anti-bot verification',
    'register.submit':              'Create my account',
    'register.submitting':          'Creating account...',
    'register.alreadyMember':       'Already a member?',
    'register.login':               'Sign in',

    'account.title':                'My Account',
    'account.subtitle':             'Manage your personal information and security settings',
    'account.tabProfile':           'Profile',
    'account.tabSecurity':          'Security',
    'account.personalInfo':         'Personal information',
    'account.loginInfo':            'Login information',
    'account.firstName':            'First name',
    'account.lastName':             'Last name',
    'account.username':             'Username',
    'account.usernameReadonly':     'Cannot be changed',
    'account.email':                'Email address',
    'account.emailInvalid':         'Invalid email format',
    'account.phone':                'Phone',
    'account.preferredLang':        'Preferred language',
    'account.langFr':               'French',
    'account.langEn':               'English',
    'account.langAr':               'Arabic',
    'account.saving':               'Saving...',
    'account.save':                 'Save changes',
    'account.role':                 'User',
    'account.changePassword':       'Change password',
    'account.currentPassword':      'Current password',
    'account.newPassword':          'New password',
    'account.passwordMin':          'Minimum 6 characters',
    'account.confirmPassword':      'Confirm password',
    'account.passwordMismatch':     'Passwords do not match',
    'account.changing':             'Changing...',
    'account.changeBtn':            'Change password',

    'contact.badge':                'Contact',
    'contact.title':                'Contact us',
    'contact.sub':                  'Our team is available to answer all your questions about the transparency of public finances in Chad.',
    'contact.hours':                'Mon – Fri: 7:30 AM – 3:30 PM',
    'contact.ourCoords':            'Our contact details',
    'contact.coordsDesc':           'Feel free to reach us through any of the channels below.',
    'contact.address':              'Address',
    'contact.phone':                'Phone',
    'contact.openHours':            'Opening hours',
    'contact.openHoursVal':         'Monday – Friday: 7:30 AM – 3:30 PM',
    'contact.followUs':             'Follow us on social media',
    'contact.formTitle':            'Send us a message',
    'contact.formDesc':             'Fill in the form below and we will get back to you as soon as possible.',
    'contact.fullName':             'Full name',
    'contact.fullNamePh':           'Your full name',
    'contact.nameRequired':         'Name is required.',
    'contact.emailInvalid':         'Invalid email.',
    'contact.subject':              'Subject',
    'contact.subjectPh':            'Subject of your message',
    'contact.message':              'Message',
    'contact.messagePh':            'Describe your request...',
    'contact.send':                 'Send message',
    'contact.sending':              'Sending...',
    'contact.successTitle':         'Message sent!',
    'contact.successDesc':          'We will get back to you as soon as possible.',
    'contact.errorTitle':           'Send error',
    'contact.errorDesc':            'An error occurred. Please try again or contact us by email.',
    'contact.findUs':               'Find us',

    'notfound.title':               'Page not found',
    'notfound.desc':                'The page you are looking for does not exist or has been moved.',
    'notfound.hint':                'Check the URL or use the links below to navigate.',
    'notfound.backHome':            'Back to home',
    'notfound.usefulLinks':         'Useful pages',

    'favorites.title':              'My Favorites',
    'favorites.sub':                'Find here all your saved datasets, publications, official texts and videos',
    'favorites.noFavs':             'No saved favorites',
    'favorites.searchPh':           'Search in your favorites...',
    'favorites.loginRequired':      'Login required',
    'favorites.loginDesc':          'Sign in to access your personal favorites.',
    'favorites.login':              'Sign in',
    'favorites.empty':              'You don\'t have any favorites yet.',
    'favorites.emptyDesc':          'Browse the site and click the star to save content.',

    'search.title':                 'Search results',
    'search.placeholder':           'Search the entire Observatory...',
    'search.btn':                   'Search',
    'search.searching':             'Searching…',
    'search.noResult':              'No results for',
    'search.noResultHint':          'Try other keywords or browse the sections below.',
    'search.results':               'result(s) for'
  },
  ar: {
    'nav.openBudget':               'الميزانية المفتوحة',
    'nav.budgetGeneral':            'الميزانية العامة',
    'nav.budgetLocal':              'الميزانية المحلية',
    'nav.budgetCitoyen':            'ميزانية المواطن',
    'nav.budgetInvestissements':    'ميزانية الاستثمارات',
    'nav.secteurPetrolier':         'قطاع النفط',
    'nav.contratsPetroliers':       'عقود النفط',
    'nav.autorisationsRecherche':   'تصاريح الاستكشاف',
    'nav.autorisationsExploitation':'تصاريح الاستغلال',
    'nav.secteurMinier':            'قطاع التعدين',
    'nav.conventionsMinieres':      'اتفاقيات التعدين',
    'nav.titresMiniers':            'حقوق التعدين',
    'nav.autorisationsMinieres':    'تصاريح التعدين',
    'nav.documents':                'وثائق',
    'nav.textesOfficiels':          'النصوص الرسمية',
    'nav.publications':             'المنشورات',
    'nav.videotheque':              'مكتبة الفيديو',
    'nav.actualites':               'أخبار',
    'nav.datasets':                 'مجموعات البيانات',
    'nav.organisations':            'المنظمات',
    'nav.glossaire':                'المعجم',
    'nav.forum':                    'المنتدى',
    'nav.contact':                  'اتصل بنا',
    'nav.secteurs':                 'القطاعات',
    'nav.ressources':               'الموارد',
    'nav.decouvrezApps':            'اكتشف جميع تطبيقاتنا',
    'nav.connexion':                'تسجيل الدخول',
    'nav.inscription':              'التسجيل',
    'nav.monCompte':                'حسابي',
    'nav.mesFavoris':               'المفضلة',
    'nav.espaceAdmin':              'فضاء الإدارة',
    'nav.deconnexion':              'تسجيل الخروج',
    'footer.question':              'سؤال أو حاجة للمساعدة؟',
    'footer.equipe':                'فريقنا متاح لمساعدتك.',
    'footer.nousContacter':         'اتصل بنا',
    'footer.droits':                'جميع الحقوق محفوظة.',
    'footer.politiqueConf':         'سياسة الخصوصية',
    'footer.mentionsLegales':       'إشعار قانوني',
    'global.menu.home':             'الرئيسية',

    'modal.logout.title':           'تسجيل الخروج؟',
    'modal.logout.body':            'ستنتهي جلستك وستُعاد توجيهك إلى صفحة تسجيل الدخول.',
    'modal.logout.cancel':          'إلغاء',
    'modal.logout.confirm':         'تسجيل الخروج',
    'modal.session.title':          'جلستك على وشك الانتهاء',
    'modal.session.expireIn':       'ستنتهي جلستك خلال',
    'modal.session.hint':           'انقر على "البقاء متصلاً" لتمديد جلستك.',
    'modal.session.logout':         'تسجيل الخروج',
    'modal.session.stay':           'البقاء متصلاً',

    'common.search':                'بحث',
    'common.searching':             'جارٍ البحث…',
    'common.loading':               'جارٍ التحميل...',
    'common.noResults':             'لا توجد نتائج لـ',
    'common.seeAllResults':         'عرض كل النتائج لـ',
    'common.visualize':             'عرض',
    'common.download':              'تنزيل',
    'common.fileUnavailable':       'الملف غير متاح',
    'common.readArticle':           'قراءة المقال',
    'common.required':              'مطلوب',
    'common.all':                   'الكل',
    'common.filter':                'تصفية',
    'common.resetFilters':          'إعادة تعيين الفلاتر',
    'common.noMatchSearch':         'لا توجد نتائج تطابق بحثك.',
    'common.showPer':               'عرض بـ:',
    'common.addFavorite':           'إضافة إلى المفضلة',
    'common.removeFavorite':        'إزالة من المفضلة',
    'common.favorite':              'مفضلة',
    'common.allCategories':         'جميع الفئات',
    'common.allYears':              'جميع السنوات',
    'common.views':                 'مشاهدة',
    'common.watch':                 'مشاهدة',
    'common.reset':                 'إعادة تعيين',
    'common.advancedFilters':       'فلاتر متقدمة',
    'common.rateDoc':               'قيّم هذا المستند:',
    'common.loadingPubs':           'جارٍ تحميل المنشورات...',
    'common.loadingActus':          'جارٍ تحميل الأخبار...',
    'common.loadingVideos':         'جارٍ تحميل الفيديوهات...',
    'common.loadingData':           'جارٍ تحميل البيانات...',

    'actualites.badge':             'أخبار',
    'actualites.title':             'الأخبار',
    'actualites.sub':               'ابقَ على اطلاع بآخر أخبار المالية العامة في تشاد',
    'actualites.articles':          'مقالات',
    'actualites.categories':        'فئات',
    'actualites.featured':          'المميز',
    'actualites.searchPh':          'ابحث عن خبر...',
    'actualites.noResult':          'لا توجد أخبار تطابق بحثك.',
    'actualites.allTitle':          'جميع الأخبار',

    'publications.badge':           'المنشورات',
    'publications.title':           'المنشورات',
    'publications.sub':             'اكتشف جميع منشورات ووثائق مرصد المالية العامة التشادي',
    'publications.searchPh':        'ابحث بالعنوان، المؤلف، الفئة، الكلمات المفتاحية...',
    'publications.noResult':        'لا توجد منشورات تطابق',
    'publications.noCategory':      'بدون فئة',

    'videotheque.badge':            'مكتبة الفيديو',
    'videotheque.title':            'مكتبة الفيديو',
    'videotheque.sub':              'استكشف موارد الفيديو من مرصد المالية العامة التشادي، بما فيها بيانات القطاع الاستخراجي.',
    'videotheque.searchPh':         'ابحث عن فيديو...',
    'videotheque.allDurations':     'جميع المدد',
    'videotheque.allMonths':        'جميع الأشهر',
    'videotheque.noResult':         'لم يُعثر على فيديوهات',
    'videotheque.noResultDesc':     'لا توجد فيديوهات تطابق معايير بحثك.',
    'videotheque.available':        'فيديوهات متاحة',
    'videotheque.short':            'قصير (< 10 دقائق)',
    'videotheque.medium':           'متوسط (10-30 دقيقة)',
    'videotheque.long':             'طويل (> 30 دقيقة)',

    'textes.badge':                 'النصوص الرسمية',
    'textes.title':                 'النصوص الرسمية',
    'textes.sub':                   'اطّلع على النصوص التشريعية والتنظيمية المتعلقة بالمالية العامة في تشاد',
    'textes.searchPh':              'ابحث عن نص رسمي...',
    'textes.noResult':              'لا توجد نصوص رسمية تطابق بحثك.',

    'forum.badge':                  'المنتدى',
    'forum.title':                  'منتدى النقاش',
    'forum.sub':                    'تبادل الآراء مع المجتمع حول المالية العامة في تشاد',
    'forum.newTopic':               'موضوع جديد',
    'forum.searchPh':               'ابحث عن موضوع...',
    'forum.noResult':               'لا توجد مواضيع تطابق بحثك.',
    'forum.loginRequired':          'يلزم تسجيل الدخول للنشر',

    'glossaire.badge':              'المعجم',
    'glossaire.title':              'المعجم',
    'glossaire.sub':                'تعريفات المصطلحات المتعلقة بالمالية العامة والشفافية',
    'glossaire.searchPh':           'ابحث عن مصطلح...',
    'glossaire.noResult':           'لا توجد مصطلحات تطابق بحثك.',

    'sector.oil.title':             'القطاع النفطي',
    'sector.oil.sub':               'بيانات وإحصاءات حول صناعة النفط في تشاد',
    'sector.oil.year':              'السنة',
    'sector.oil.production':        'الإنتاج',

    'contrats.badge':               'القطاع النفطي',
    'contrats.title':               'العقود النفطية',
    'contrats.sub':                 'الاتفاقيات المبرمة بين الدولة التشادية وشركات النفط لاستكشاف واستغلال الموارد النفطية',
    'contrats.searchPh':            'ابحث بالاسم، الرقم الضريبي، المرجع...',
    'contrats.filters':             'فلاتر البحث',
    'contrats.denomination':        'التسمية',
    'contrats.matiere':             'المادة المتعاقد عليها',
    'contrats.type':                'نوع العقد',
    'contrats.status':              'الحالة',
    'contrats.noResult':            'لا توجد عقود تطابق بحثك.',

    'conventions.badge':            'قطاع التعدين',
    'conventions.title':            'الاتفاقيات المعدنية',
    'conventions.sub':              'قائمة الاتفاقيات المعدنية الموقعة بين الدولة التشادية وشركات التعدين لاستكشاف واستغلال الموارد المعدنية',
    'conventions.searchPh':         'ابحث عن اتفاقية...',
    'conventions.filters':          'فلاتر البحث',
    'conventions.keyword':          'كلمة مفتاحية',
    'conventions.region':           'المنطقة',
    'conventions.allRegions':       'جميع المناطق',
    'conventions.substance':        'المادة',
    'conventions.allSubstances':    'جميع المواد',
    'conventions.allStatuts':       'جميع الحالات',
    'conventions.anneeMin':         'السنة الدنيا',
    'conventions.noResult':         'لا توجد اتفاقيات تطابق بحثك.',

    'titres.badge':                 'قطاع التعدين',
    'titres.title':                 'حقوق التعدين',
    'titres.sub':                   'حقوق التعدين الممنوحة من الدولة التشادية لاستكشاف واستغلال الموارد المعدنية',
    'titres.searchPh':              'ابحث عن حق تعدين...',
    'titres.noResult':              'لا توجد حقوق تعدين تطابق بحثك.',

    'autorisations.badge':          'القطاع النفطي',
    'autorisations.searchPh':       'ابحث عن ترخيص...',
    'autorisations.noResult':       'لا توجد تراخيص تطابق بحثك.',
    'autorisations.recherche.title':'تراخيص الاستكشاف',
    'autorisations.recherche.sub':  'التراخيص الممنوحة لاستكشاف الهيدروكربونات في تشاد',
    'autorisations.exploitation.title': 'تراخيص الاستغلال',
    'autorisations.exploitation.sub':   'التراخيص الممنوحة لاستغلال الهيدروكربونات في تشاد',
    'autorisations.minieres.badge': 'قطاع التعدين',
    'autorisations.minieres.title': 'التراخيص المعدنية',
    'autorisations.minieres.sub':   'التراخيص الممنوحة للاستكشاف والاستغلال المعدني في تشاد',

    'apps.badge':                   'تطبيقات الجوال',
    'apps.title':                   'تطبيقاتنا',
    'apps.sub':                     'الوصول إلى بيانات وخدمات المالية التشادية مباشرة من هاتفك الذكي',
    'apps.downloadIos':             'تنزيل على',
    'apps.downloadAndroid':         'متاح على',

    'footer.community':             'انضم إلينا',
    'footer.brandDesc':             'منصة وطنية لشفافية المالية العامة، تتيح الوصول إلى بيانات الميزانية والبيانات المالية في تشاد.',
    'footer.followUs':              'تابعونا',
    'footer.mobileApps':            'تطبيقات الجوال',
    'footer.applications':          'التطبيقات',

    'footer.stat.datasets':         'مجموعات البيانات',
    'footer.stat.publications':     'المنشورات',
    'footer.stat.textes':           'النصوص الرسمية',
    'footer.stat.users':            'مستخدمون',

    'newsletter.title':             'النشرة الإخبارية',
    'newsletter.desc':              'اشترك لتلقي النشرة الإخبارية الشهرية والبقاء على اطلاع بآخر أخبار المرصد.',
    'newsletter.placeholder':       'عنوان بريدك الإلكتروني',
    'newsletter.btn':               'اشتراك',
    'newsletter.success':           'شكراً لاشتراكك!',

    'legal.badge':                  'معلومات قانونية',
    'legal.title':                  'إشعار قانوني',
    'legal.update':                 'آخر تحديث: مايو 2026',

    'privacy.badge':                'البيانات الشخصية',
    'privacy.title':                'سياسة الخصوصية',
    'privacy.update':               'آخر تحديث: مايو 2026',

    'home.heroTag':                 'الشفافية والمالية العامة',
    'home.heroSubtitle':            'الوصول إلى البيانات المالية والتعدينية والنفطية لتشاد',
    'home.searchPlaceholder':       'ابحث في المرصد…',
    'home.budgetTitle':             'الميزانية المفتوحة — مجموعات البيانات',
    'home.budgetDesc':              'معلومات قوانين المالية السنوية وتقييم الأداء الميزاني وتوزيع الإيرادات والنفقات.',
    'home.videosTitle':             'أحدث مقاطع الفيديو',
    'home.videosDesc':              'ملاحظات القطاع الاستخراجي، مقاطع فيديو توضيحية حول قوانين المالية وأخبار المالية العامة في تشاد.',
    'home.videosBtn':               'تصفح جميع الفيديوهات',
    'home.appPretitle':             'تطبيق الجوال',
    'home.appTitle':                'مرصد المالية العامة التشادي',
    'home.appDesc':                 'رفيقك الجديد لمعرفة كل شيء عن المالية العامة في تشاد',
    'home.pubBadge':                'المنشورات',
    'home.pubSectionTitle':         'الموارد الوثائقية',
    'home.pubSectionDesc':          'تقارير ودراسات ووثائق رسمية حول المالية العامة في تشاد',
    'home.pubAllLink':              'جميع المنشورات',
    'home.pubRecent':               'أحدث المنشورات',
    'home.pubFeatured':             'المنشورات المميزة',
    'home.pubNoRecent':             'لا توجد منشورات حديثة',
    'home.pubNoFeatured':           'لا توجد منشورات مميزة',
    'home.actuBadge':               'أخبار',
    'home.actuTitle':               'آخر الأخبار',
    'home.actuDesc':                'تابع آخر أخبار المالية العامة في تشاد',
    'home.actuAllLink':             'عرض كل الأخبار',
    'home.actuEmpty':               'لا تتوفر أخبار في الوقت الحالي.',
    'home.actuAllBtn':              'جميع الأخبار',
    'home.views':                   'مشاهدة',

    'login.welcome':                'مرحباً بعودتك!',
    'login.subtitle':               'سجّل الدخول إلى مساحتك الشخصية',
    'login.successMsg':             'تم إنشاء الحساب بنجاح. يمكنك تسجيل الدخول الآن.',
    'login.username':               'اسم المستخدم',
    'login.usernamePlaceholder':    'معرّفك',
    'login.usernameRequired':       'اسم المستخدم مطلوب',
    'login.password':               'كلمة المرور',
    'login.passwordPlaceholder':    'كلمة مرورك',
    'login.passwordRequired':       'كلمة المرور مطلوبة',
    'login.rememberMe':             'تذكّرني',
    'login.forgotPassword':         'نسيت كلمة المرور؟',
    'login.submit':                 'تسجيل الدخول',
    'login.submitting':             'جارٍ الدخول...',
    'login.noAccount':              'ليس لديك حساب؟',
    'login.createAccount':          'إنشاء حساب',
    'login.feature1':               'الوصول إلى البيانات الميزانية',
    'login.feature2':               'متابعة الموارد النفطية والتعدينية',
    'login.feature3':               'النصوص الرسمية والمنشورات',

    'register.title':               'إنشاء حساب',
    'register.subtitle':            'أكمل النموذج للتسجيل',
    'register.step1':               'أنشئ حسابك مجاناً',
    'register.step2':               'الوصول إلى البيانات والمنشورات',
    'register.step3':               'المشاركة في نقاشات المنتدى',
    'register.firstName':           'الاسم الأول',
    'register.firstNamePh':         'اسمك الأول',
    'register.lastName':            'اللقب',
    'register.lastNamePh':          'لقبك',
    'register.username':            'اسم المستخدم',
    'register.usernamePh':          'اختر معرّفاً (3–20 حرفاً)',
    'register.usernameRequired':    'اسم المستخدم مطلوب',
    'register.usernameMin':         'الحد الأدنى 3 أحرف',
    'register.usernameMax':         'الحد الأقصى 20 حرفاً',
    'register.email':               'البريد الإلكتروني',
    'register.emailRequired':       'البريد الإلكتروني مطلوب',
    'register.emailInvalid':        'البريد الإلكتروني غير صحيح',
    'register.password':            'كلمة المرور',
    'register.passwordPh':          'الحد الأدنى 6 أحرف',
    'register.passwordMin':         'الحد الأدنى 6 أحرف',
    'register.confirm':             'تأكيد كلمة المرور',
    'register.confirmPh':           'أعد كلمة المرور',
    'register.confirmMismatch':     'كلمتا المرور غير متطابقتين',
    'register.terms':               'أوافق على',
    'register.termsLink':           'شروط الاستخدام',
    'register.and':                 'و',
    'register.privacyLink':         'سياسة الخصوصية',
    'register.termsRequired':       'يجب قبول شروط الاستخدام',
    'register.captcha':             'التحقق من مكافحة الروبوت',
    'register.captchaRequired':     'يرجى إتمام التحقق من مكافحة الروبوت',
    'register.submit':              'إنشاء حسابي',
    'register.submitting':          'جارٍ الإنشاء...',
    'register.alreadyMember':       'لديك حساب بالفعل؟',
    'register.login':               'تسجيل الدخول',

    'account.title':                'حسابي',
    'account.subtitle':             'إدارة المعلومات الشخصية وإعدادات الأمان',
    'account.tabProfile':           'الملف الشخصي',
    'account.tabSecurity':          'الأمان',
    'account.personalInfo':         'المعلومات الشخصية',
    'account.loginInfo':            'معلومات تسجيل الدخول',
    'account.firstName':            'الاسم الأول',
    'account.lastName':             'اللقب',
    'account.username':             'اسم المستخدم',
    'account.usernameReadonly':     'لا يمكن تغييره',
    'account.email':                'البريد الإلكتروني',
    'account.emailInvalid':         'صيغة البريد الإلكتروني غير صحيحة',
    'account.phone':                'الهاتف',
    'account.preferredLang':        'اللغة المفضلة',
    'account.langFr':               'الفرنسية',
    'account.langEn':               'الإنجليزية',
    'account.langAr':               'العربية',
    'account.saving':               'جارٍ الحفظ...',
    'account.save':                 'حفظ التعديلات',
    'account.role':                 'مستخدم',
    'account.changePassword':       'تغيير كلمة المرور',
    'account.currentPassword':      'كلمة المرور الحالية',
    'account.newPassword':          'كلمة المرور الجديدة',
    'account.passwordMin':          'الحد الأدنى 6 أحرف',
    'account.confirmPassword':      'تأكيد كلمة المرور',
    'account.passwordMismatch':     'كلمتا المرور غير متطابقتين',
    'account.changing':             'جارٍ التغيير...',
    'account.changeBtn':            'تغيير كلمة المرور',

    'contact.badge':                'اتصل بنا',
    'contact.title':                'تواصل معنا',
    'contact.sub':                  'فريقنا متاح للإجابة على جميع أسئلتك حول شفافية المالية العامة في تشاد.',
    'contact.hours':                'الإثنين – الجمعة: 7:30 – 15:30',
    'contact.ourCoords':            'معلومات الاتصال',
    'contact.coordsDesc':           'لا تتردد في التواصل معنا عبر أي من القنوات أدناه.',
    'contact.address':              'العنوان',
    'contact.phone':                'الهاتف',
    'contact.openHours':            'ساعات العمل',
    'contact.openHoursVal':         'الإثنين – الجمعة: 7:30 – 15:30',
    'contact.followUs':             'تابعنا على وسائل التواصل الاجتماعي',
    'contact.formTitle':            'أرسل لنا رسالة',
    'contact.formDesc':             'أكمل النموذج أدناه وسنرد عليك في أقرب وقت ممكن.',
    'contact.fullName':             'الاسم الكامل',
    'contact.fullNamePh':           'اسمك الكامل',
    'contact.nameRequired':         'الاسم مطلوب.',
    'contact.emailInvalid':         'البريد الإلكتروني غير صحيح.',
    'contact.subject':              'الموضوع',
    'contact.subjectPh':            'موضوع رسالتك',
    'contact.message':              'الرسالة',
    'contact.messagePh':            'صف طلبك...',
    'contact.send':                 'إرسال الرسالة',
    'contact.sending':              'جارٍ الإرسال...',
    'contact.successTitle':         'تم إرسال الرسالة!',
    'contact.successDesc':          'سنرد عليك في أقرب وقت ممكن.',
    'contact.errorTitle':           'خطأ في الإرسال',
    'contact.errorDesc':            'حدث خطأ. يرجى المحاولة مجدداً أو التواصل معنا عبر البريد الإلكتروني.',
    'contact.findUs':               'موقعنا',

    'notfound.title':               'الصفحة غير موجودة',
    'notfound.desc':                'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
    'notfound.hint':                'تحقق من الرابط أو استخدم الروابط أدناه للتنقل.',
    'notfound.backHome':            'العودة إلى الرئيسية',
    'notfound.usefulLinks':         'صفحات مفيدة',

    'favorites.title':              'مفضلتي',
    'favorites.sub':                'ابحث هنا عن جميع مجموعات البيانات والمنشورات والنصوص الرسمية والفيديوهات المحفوظة',
    'favorites.noFavs':             'لا توجد مفضلات محفوظة',
    'favorites.searchPh':           'ابحث في مفضلاتك...',
    'favorites.loginRequired':      'يلزم تسجيل الدخول',
    'favorites.loginDesc':          'سجّل الدخول للوصول إلى مفضلاتك الشخصية.',
    'favorites.login':              'تسجيل الدخول',
    'favorites.empty':              'ليس لديك مفضلات بعد.',
    'favorites.emptyDesc':          'تصفح الموقع وانقر على النجمة لحفظ المحتوى.',

    'search.title':                 'نتائج البحث',
    'search.placeholder':           'ابحث في المرصد...',
    'search.btn':                   'بحث',
    'search.searching':             'جارٍ البحث…',
    'search.noResult':              'لا توجد نتائج لـ',
    'search.noResultHint':          'جرّب كلمات مفاتيح أخرى أو تصفح الأقسام أدناه.',
    'search.results':               'نتيجة (نتائج) لـ'
  }
};

console.log('[i18n] i18n-config.js chargé');

angular.module(appModule)
.config(['$translateProvider', function($translateProvider) {

  console.log('[i18n] config block exécuté, enregistrement des traductions...');
  $translateProvider
    .translations('fr', TRANSLATIONS.fr)
    .translations('en', TRANSLATIONS.en)
    .translations('ar', TRANSLATIONS.ar)
    .useSanitizeValueStrategy(null)
    .fallbackLanguage('fr')
    .preferredLanguage('fr');
}])

.run(['$translate', '$rootScope', function($translate, $rootScope) {
  function applyDir(lang) {
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }
  applyDir($translate.use() || 'fr');
  $rootScope.$on('$translateChangeSuccess', function(e, data) {
    applyDir(data.language);
  });
}]);
